<div class="priority-header">
  <button type="button" class="ps-scope-toggle" (click)="toggleStage()" [attr.aria-expanded]="isExpanded">
    <span class="ps-scope-toggle-left">
      <ps-outline-icon [name]="isExpanded ? 'chevron-down' : 'chevron-right'"></ps-outline-icon>
      <span class="ps-scope-name">{{stage.StageName}}</span>
    </span>
    <span class="ps-scope-pct" *ngIf="!isExpanded && stage.PercentComplete != null">{{stage.PercentComplete}}%</span>
  </button>
</div>

<div class="ps-stage-content" *ngIf="isExpanded">
  <div class="execution row align-items-center justify-content-end">
    <ng-container *ngIf="showPercentage('unitPercentComplete')">
      <div class="col col-md-10">
        - Unit % Complete
        <div class="progress">
          <div [class.progress-inprogress]="stage.PercentComplete < 100"
            [class.progress-complete]="stage.PercentComplete === 100" class="progress-bar" role="progressbar"
            [style.width]="stage.PercentComplete+'%'" attr.aria-valuenow="{{stage.PercentComplete}}" aria-valuemin="0"
            aria-valuemax="100" [attr.title]="stage.PercentComplete + '%'">
          </div>
        </div>
      </div>
      <div style="text-align: right" class="col col-md-2  mx-0 pl-0 label-text">{{stage.PercentComplete}}%</div>
    </ng-container>
    <ng-container *ngIf="showPercentage('durationPercentComplete')">
      <div class="col col-md-10">
        - Duration % Complete
        <div class="progress">
          <div [class.progress-inprogress]="stage.DurationPercentComplete < 100"
            [class.progress-complete]="stage.DurationPercentComplete === 100" class="progress-bar" role="progressbar"
            [style.width]="stage.DurationPercentComplete+'%'" attr.aria-valuenow="{{stage.DurationPercentComplete}}"
            aria-valuemin="0" aria-valuemax="100" [attr.title]="stage.DurationPercentComplete + '%'">
          </div>
        </div>
      </div>
      <div style="text-align: right" class="col col-md-2  mx-0 pl-0 label-text">{{stage.DurationPercentComplete}}%</div>
    </ng-container>
  </div>

  <div class="ps-stage-children" *ngIf="hasChildren">
    <div class="row stage-children-wbs" *ngFor="let stageChild of stage.Stages">
      <div class="col-md-12 label-text">{{stageChild.StageName}}</div>
      <div class="col-md-12">
        <ng-container *ngIf="showPercentage('unitPercentComplete')">
          <!-- <ng-container *ngIf="stage.StageName != 'MILESTONES'; else durationLabel"> -->

          <div class="row mb-1">
            <div class="col fw-bold">- Unit % Complete</div>
          </div>
          <div class="row align-items-center flex-nowrap">
            <div class="col">
              <div class="progress">
                <div [class.progress-inprogress]="stageChild.PercentComplete < 100"
                  [class.progress-complete]="stageChild.PercentComplete === 100" class="progress-bar" role="progressbar"
                  [style.width]="stageChild.PercentComplete + '%'" [attr.title]="stageChild.PercentComplete + '%'">
                </div>
              </div>
            </div>
            <div class="col-auto text-end label-text">
              {{ stageChild.PercentComplete }}%
            </div>
          </div>
        </ng-container>

        <!-- <ng-container
          '*ngIf="(+stageChild.DurationComplete > 0 || (+stageChild.PercentComplete == 0 && +stageChild.DurationComplete == 0) && showPercentage('durationPercentComplete'))"> -->
        <ng-container *ngIf="showPercentage('durationPercentComplete')">
          <div class="row mb-1">
            <div class="col fw-bold">- Duration % Complete</div>
          </div>
          <div class="row align-items-center flex-nowrap">
            <div class="col">
              <div class="progress">
                <div [class.progress-inprogress]="stageChild.DurationComplete < 100"
                  [class.progress-complete]="stageChild.DurationComplete === 100" class="progress-bar" role="progressbar"
                  [style.width]="stageChild.DurationComplete + '%'" [attr.title]="stageChild.DurationComplete + '%'">
                </div>
              </div>
            </div>
            <div class="col-auto text-end label-text">
              {{ stageChild.DurationComplete }}%
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>